import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { matTooltipSetter } from '../../functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-feature-list-item',
  templateUrl: './feature-list-item.component.html',
  styleUrls: ['./feature-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureListItemComponent {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input() label: string;
  @Input() description: string;
  @Input() value: string | string[];
  @Input() replaceValueWithElement = false;
  @Input() error: boolean;
  @Input() warning: boolean;
  @Input() disabled: boolean;
  @Input() editable: boolean;
  @Input() isNgContent: boolean;
  @Input() forInput: boolean;
  @Input() timestamp: string;
  @Input() labelInfoTooltip: string;
  @Input() valueInfoTooltip: string;
  @Input() arrayHorizontalDisplay = false;
  @Input() suffix: string;
  @Input() beta: string;
  @Output() edit = new EventEmitter<void>();

  get asArray(): boolean {
    return Array.isArray(this.value);
  }
}
